module.exports = __webpack_public_path__ + "static/media/Image4.db57462d.svg";